export const CATEGORIES_REQUEST = 'CATEGORIES_REQUEST';
export const CATEGORIES_SUCCESS = 'CATEGORIES_SUCCESS';
export const CATEGORIES_GET_SUCCESS = 'CATEGORIES_GET_SUCCESS';
export const CATEGORIES_VALIDATION_ERROR = 'CATEGORIES_VALIDATION_ERROR';
export const CATEGORIES_REDIRECT = 'CATEGORIES_REDIRECT';
export const HIDE_CATEGORIES_FEILD_VALIDATION_ERROR = 'HIDE_CATEGORIES_FEILD_VALIDATION_ERROR';

export const TASKS_REQUEST = 'TASKS_REQUEST';
export const TASKS_SUCCESS = 'TASKS_SUCCESS';
export const TASKS_GET_SUCCESS = 'TASKS_GET_SUCCESS';
export const TASKS_VALIDATION_ERROR = 'TASKS_VALIDATION_ERROR';
export const TASKS_REDIRECT = 'TASKS_REDIRECT';
export const HIDE_TASKS_FEILD_VALIDATION_ERROR = 'HIDE_TASKS_FEILD_VALIDATION_ERROR';

export const CATEGORIES_DROPDOWN_SUCCESS = 'CATEGORIES_DROPDOWN_SUCCESS';
export const TASKS_DROPDOWN_SUCCESS = 'TASKS_DROPDOWN_SUCCESS';

export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';

export const PROGRAM_SETUP_CATEGORIES_REQUEST = 'PROGRAM_SETUP_CATEGORIES_REQUEST';
export const PROGRAM_SETUP_VALIDATION_ERROR = 'PROGRAM_SETUP_VALIDATION_ERROR';
export const PROGRAM_SETUP_CATEGORIES_REDIRECT = 'PROGRAM_SETUP_CATEGORIES_REDIRECT';
export const FETCH_PROGRAM_SETUPS = 'FETCH_PROGRAM_SETUPS';
export const PROGRAM_SETUP_GET_SUCCESS = 'PROGRAM_SETUP_GET_SUCCESS';
export const FETCH_BOUND_TASKS = 'FETCH_BOUND_TASKS';
export const FETCH_BOUND_USERS = 'FETCH_BOUND_USERS';
export const UPDATE_PROGRAM_SETUP_SUCCESS = 'UPDATE_PROGRAM_SETUP_SUCCESS';
export const DETACH_PROGRAM_SETUP_SUCCESS = 'DETACH_PROGRAM_SETUP_SUCCESS';
export const UNBIND_TASK = 'UNBIND_TASK';
export const UNBIND_USER = 'UNBIND_USER';

// Weekly Timesheets
export const WEEKLY_TIMESHEET_REQUEST = 'WEEKLY_TIMESHEET_REQUEST';
export const WEEKLY_TIMESHEET_SUCCESS = 'WEEKLY_TIMESHEET_SUCCESS';
export const WEEKLY_TIMESHEET_GET_SUCCESS = 'WEEKLY_TIMESHEET_GET_SUCCESS';
export const WEEKLY_TIMESHEET_VALIDATION_ERROR = 'WEEKLY_TIMESHEET_VALIDATION_ERROR';
export const WEEKLY_TIMESHEET_REDIRECT = 'WEEKLY_TIMESHEET_REDIRECT';
export const HIDE_WEEKLY_TIMESHEET_FEILD_VALIDATION_ERROR = 'HIDE_WEEKLY_TIMESHEET_FEILD_VALIDATION_ERROR';
export const WEEKLY_TIMESHEET_DETAILS_SUCCESS = 'WEEKLY_TIMESHEET_DETAILS_SUCCESS';
export const CLEAR_WEEKLY_TIMESHEETS = 'CLEAR_WEEKLY_TIMESHEETS';
export const GET_WEEKLY_TIMESHEET_SUCCESS = 'GET_WEEKLY_TIMESHEET_SUCCESS';
export const GET_WEEKLY_TIMESHEET_FAILURE = 'GET_WEEKLY_TIMESHEET_FAILURE';

export const GET_MONTHLY_PROGRAM_TIMESHEET_REQUEST = 'GET_MONTHLY_PROGRAM_TIMESHEET_REQUEST';
export const GET_MONTHLY_PROGRAM_TIMESHEET_SUCCESS = 'GET_MONTHLY_PROGRAM_TIMESHEET_SUCCESS';
export const GET_MONTHLY_PROGRAM_TIMESHEET_FAILURE = 'GET_MONTHLY_PROGRAM_TIMESHEET_FAILURE';
export const CLEAR_MONTHLY_PROGRAM_TIMESHEETS_REPORT = 'CLEAR_MONTHLY_PROGRAM_TIMESHEETS_REPORT';   

export const GET_MONTHLY_USER_TIMESHEET_REQUEST = 'GET_MONTHLY_USER_TIMESHEET_REQUEST';
export const GET_MONTHLY_USER_TIMESHEET_SUCCESS = 'GET_MONTHLY_USER_TIMESHEET_SUCCESS';
export const GET_MONTHLY_USER_TIMESHEET_FAILURE = 'GET_MONTHLY_USER_TIMESHEET_FAILURE';
export const CLEAR_MONTHLY_USER_TIMESHEETS_REPORT = 'CLEAR_MONTHLY_USER_TIMESHEETS_REPORT';

export const GET_WEEKLY_SUMMARY_TIMESHEET_REQUEST = 'GET_WEEKLY_SUMMARY_TIMESHEET_REQUEST';
export const GET_WEEKLY_SUMMARY_TIMESHEET_SUCCESS = 'GET_WEEKLY_SUMMARY_TIMESHEET_SUCCESS';
export const GET_WEEKLY_SUMMARY_TIMESHEET_FAILURE = 'GET_WEEKLY_SUMMARY_TIMESHEET_FAILURE';
export const CLEAR_WEEKLY_SUMMARY_TIMESHEETS_REPORT = 'CLEAR_WEEKLY_SUMMARY_TIMESHEETS_REPORT';

export const GET_MONTHLY_DETAILED_TIMESHEET_REQUEST = 'GET_MONTHLY_DETAILED_TIMESHEET_REQUEST';
export const GET_MONTHLY_DETAILED_TIMESHEET_SUCCESS = 'GET_MONTHLY_DETAILED_TIMESHEET_SUCCESS';
export const GET_MONTHLY_DETAILED_TIMESHEET_FAILURE = 'GET_MONTHLY_DETAILED_TIMESHEET_FAILURE';
export const CLEAR_MONTHLY_DETAILED_TIMESHEETS_REPORT = 'CLEAR_MONTHLY_DETAILED_TIMESHEETS_REPORT';

export const GET_CATEGORY_SUMMARY_REPORT_REQUEST = 'GET_CATEGORY_SUMMARY_REPORT_REQUEST';
export const GET_CATEGORY_SUMMARY_REPORT_SUCCESS = 'GET_CATEGORY_SUMMARY_REPORT_SUCCESS';
export const GET_CATEGORY_SUMMARY_REPORT_FAILURE = 'GET_CATEGORY_SUMMARY_REPORT_FAILURE';
export const CLEAR_CATEGORY_SUMMARY_REPORT = 'CLEAR_CATEGORY_SUMMARY_REPORT';

export const GET_ACCOUNT_MANAGER_MONTHLY_REPORT_REQUEST = 'GET_ACCOUNT_MANAGER_MONTHLY_REPORT_REQUEST';
export const GET_ACCOUNT_MANAGER_MONTHLY_REPORT_SUCCESS = 'GET_ACCOUNT_MANAGER_MONTHLY_REPORT_SUCCESS';
export const GET_ACCOUNT_MANAGER_MONTHLY_REPORT_FAILURE = 'GET_ACCOUNT_MANAGER_MONTHLY_REPORT_FAILURE';
export const CLEAR_ACCOUNT_MANAGER_MONTHLY_REPORT = 'CLEAR_ACCOUNT_MANAGER_MONTHLY_REPORT';